// import React, { useState, useEffect } from "react";
// import styled, { keyframes } from "styled-components";
// import { FaTimes } from "react-icons/fa";
// import image1 from "../assets/bg-image.png";
// import pdf from "../assets/doc.pdf";
// import emailjs from 'emailjs-com'; 

// const fadeIn = keyframes`
//   0% {
//     opacity: 0;
//   }
//   100% {
//     opacity: 1;
//   }
// `;

// const scaleUp = keyframes`
//   0% {
//     transform: scale(0.95);
//   }
//   100% {
//     transform: scale(1);
//   }
// `;

// const Master = () => {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [isFormVisible, setIsFormVisible] = useState(false);
//   const [isFormSubmitted, setIsFormSubmitted] = useState(false);
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     message: "",
//   });

//   const images = [`url(${image1})`];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [images.length]);

//   const handleDownloadClick = () => {
//     setIsFormVisible(true);
//   };

//   const handleFormSubmit = (e) => {
//     e.preventDefault();
//     emailjs
//       .sendForm("service_wbklszm", "template_wwfbmjm", e.target, "xm4j5IisX35o5jpNc")
//       .then((result) => {
//         console.log(result.text); 
//         setIsFormSubmitted(true);
//         setIsFormVisible(false);
//         setFormData({
//           name: "",
//           phone: "",
//           email: "",
//           message: "",
//         });

//         setTimeout(() => {
//           window.open(pdf, "_blank"); 
//         }, 500);
//       })
//       .catch((error) => {
//         console.error("Error sending email:", error);
//         alert("There was an error submitting the form. Please try again later.");
//       });
//   };

//   const handleCloseForm = () => {
//     setIsFormVisible(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   return (
//     <Container background={images[currentImageIndex]} id="master">
//       <Card>
//         <CardContent>
//           <Heading>Master Plan</Heading>
//           <Paragraph>
//             Unlock the secrets to mastering your craft. Download our PDF to get
//             started with your journey to success.
//           </Paragraph>
//           <DownloadButton onClick={handleDownloadClick}>
//             Download PDF
//           </DownloadButton>
//         </CardContent>
//       </Card>
//       {isFormVisible && (
//         <FormOverlay>
//           <ContactForm onSubmit={handleFormSubmit}>
//             <CloseIcon onClick={handleCloseForm}>
//               <FaTimes />
//             </CloseIcon>
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               placeholder="Your Name"
//               required
//               onChange={handleInputChange}
//             />
//             <input
//               type="text"
//               name="phone"
//               value={formData.phone}
//               placeholder="Your Phone Number"
//               required
//               onChange={handleInputChange}
//             />
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               placeholder="Your Email"
//               required
//               onChange={handleInputChange}
//             />
//             <textarea
//               name="message"
//               rows="4"
//               value={formData.message}
//               placeholder="Your Message"
//               required
//               onChange={handleInputChange}
//             ></textarea>
//             <button type="submit">Submit</button>
//           </ContactForm>
//         </FormOverlay>
//       )}
//     </Container>
//   );
// };

// const Container = styled.div`
//   position: relative;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: 80vh;
//   overflow: hidden;
//   background: ${({ background }) => background};
//   background-position: center;
//   background-size: cover;

//   @media (max-width: 768px) {
//     height: 60vh;
//   }

//   @media (max-width: 480px) {
//     height: 60vh;
//     width: 100%;
//   }
// `;

// const Card = styled.div`
//   background-color: rgba(0, 0, 0, 0.7);
//   border-radius: 10px;
//   padding: 40px;
//   text-align: center;
//   width: 80%;
//   max-width: 400px;
//   box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
//   animation: ${fadeIn} 2s ease-in-out, ${scaleUp} 0.8s ease-in-out forwards;

//   @media (max-width: 768px) {
//     width: 90%;
//     max-width: 350px;
//     padding: 30px;
//   }

//   @media (max-width: 480px) {
//     width: 100%;
//     max-width: 300px;
//     padding: 20px;
//   }
// `;

// const CardContent = styled.div`
//   padding: 20px;
// `;

// const Heading = styled.h1`
//   font-size: 3rem;
//   color: #fff;
//   margin-bottom: 20px;
//   animation: ${fadeIn} 2s ease-in-out;
// `;

// const Paragraph = styled.p`
//   font-size: 1.5rem;
//   color: #ddd;
//   margin-bottom: 20px;
//   animation: ${fadeIn} 2s ease-in-out;
// `;

// const DownloadButton = styled.button`
//   display: inline-block;
//   background-color: #007bff;
//   color: white;
//   padding: 15px 30px;
//   border: none;
//   border-radius: 5px;
//   font-size: 1.5rem;
//   cursor: pointer;
//   transition: background-color 0.3s ease;
//   animation: ${fadeIn} 2s ease-in-out;

//   &:hover {
//     background-color: #0056b3;
//   }
// `;

// const FormOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.7);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 1000;
// `;

// const ContactForm = styled.form`
//   position: relative;
//   background-color: #000000b3;
//   padding: 30px;
//   border-radius: 10px;
//   width: 90%;
//   max-width: 400px;
//   box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);

//   input,
//   textarea {
//     width: 100%;
//     padding: 10px 0;
//     margin-bottom: 15px;
//     border: none;
//     border-bottom: 1px solid #555;
//     font-size: 1.2rem;
//     background-color: transparent;
//     color: #fff;
//     outline: none;
//     position: relative;
//   }

//   input:focus,
//   textarea:focus {
//     border-bottom: 2px solid #f39c12;
//   }

//   input::placeholder,
//   textarea::placeholder {
//     color: rgba(255, 255, 255, 0.7);
//     transition: all 0.3s ease;
//     transform: translateY(0);
//   }

//   input:focus::placeholder,
//   textarea:focus::placeholder {
//     transform: translateY(-15px);
//     font-size: 0.9rem;
//     color: rgba(255, 255, 255, 1);
//   }

//   button {
//     width: 100%;
//     padding: 10px;
//     font-size: 1.4rem;
//     color: #fff;
//     background-color: #f39c12;
//     border: none;
//     border-radius: 5px;
//     cursor: pointer;
//     transition: all 0.3s ease;

//     &:hover {
//       background-color: rgb(245, 127, 23);
//     }
//   }
// `;

// const CloseIcon = styled.div`
//   position: absolute;
//   top: 10px;
//   right: 10px;
//   font-size: 1.8rem;
//   color: #fff;
//   cursor: pointer;
//   background-color: rgba(0, 0, 0, 0.7);
//   padding: 5px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   z-index: 1001;

//   &:hover {
//     background-color: rgba(0, 0, 0, 0.9);
//   }
// `;

// export default Master;

import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { FaTimes } from "react-icons/fa";
import image1 from "../assets/bg-image.png";
import pdf from "../assets/doc.pdf";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const scaleUp = keyframes`
  0% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
`;

const Master = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [phoneError, setPhoneError] = useState("");

  const images = [`url(${image1})`];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  const handleDownloadClick = () => {
    setIsFormVisible(true);
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    
    if (/^\d*$/.test(value) && value.length <= 10) {
      setFormData({
        ...formData,
        phone: value,
      });
      setPhoneError(""); 
    } else if (value.length > 10) {
      setPhoneError("Phone number cannot be more than 10 digits.");
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("entry.339936493", formData.name);
    formDataToSubmit.append("entry.955169212", formData.phone);
    formDataToSubmit.append("entry.899836043", formData.email);
    formDataToSubmit.append("entry.3326149", formData.message);

    fetch("https://docs.google.com/forms/u/0/d/e/1FAIpQLSc9OTP4ayAqFwnUn9gjKJYPvMUcTmycSSagb1NaF8o4Suxceg/formResponse", {
      method: "POST",
      body: formDataToSubmit,
      mode: "no-cors",
    })
      .then((response) => {
        console.log("Form submitted successfully", response);

        setIsFormSubmitted(true);
        setIsFormVisible(false);
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });

        setTimeout(() => {
          window.open(pdf, "_blank");
        }, 500);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        alert("There was an error submitting the form. Please try again later.");
      });
  };

  const handleCloseForm = () => {
    setIsFormVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <Container background={images[currentImageIndex]} id="master">
      <Card>
        <CardContent>
          <Heading>Master Plan</Heading>
          <Paragraph>
            Unlock the secrets to mastering your craft. Download our PDF to get
            started with your journey to success.
          </Paragraph>
          <DownloadButton onClick={handleDownloadClick}>Download PDF</DownloadButton>
        </CardContent>
      </Card>
      {isFormVisible && (
        <FormOverlay>
          <ContactForm onSubmit={handleFormSubmit}>
            <CloseIcon onClick={handleCloseForm}>
              <FaTimes />
            </CloseIcon>
            <input
              type="text"
              name="name"
              value={formData.name}
              placeholder="Your Name"
              required
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="phone"
              value={formData.phone}
              placeholder="Your Phone Number"
              required
              onChange={handlePhoneChange} 
            />
            
            {phoneError && <ErrorMessage>{phoneError}</ErrorMessage>}
            <input
              type="email"
              name="email"
              value={formData.email}
              placeholder="Your Email"
              required
              onChange={handleInputChange}
            />
            <textarea
              name="message"
              rows="4"
              value={formData.message}
              placeholder="Your Message"
              required
              onChange={handleInputChange}
            ></textarea>
            <button type="submit">Submit</button>
          </ContactForm>
        </FormOverlay>
      )}
    </Container>
  );
};

const ErrorMessage = styled.p`
  color: red;
  font-size: 1.2rem;
  margin-top: 5px;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  overflow: hidden;
  background: ${({ background }) => background};
  background-position: center;
  background-size: cover;

  @media (max-width: 768px) {
    height: 60vh;
  }

  @media (max-width: 480px) {
    height: 60vh;
    width: 100%;
  }
`;

const Card = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  padding: 40px;
  text-align: center;
  width: 80%;
  max-width: 400px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 2s ease-in-out, ${scaleUp} 0.8s ease-in-out forwards;

  @media (max-width: 768px) {
    width: 90%;
    max-width: 350px;
    padding: 30px;
  }

  @media (max-width: 480px) {
    width: 100%;
    max-width: 300px;
    padding: 20px;
  }
`;

const CardContent = styled.div`
  padding: 20px;
`;

const Heading = styled.h1`
  font-size: 3rem;
  color: #fff;
  margin-bottom: 20px;
  animation: ${fadeIn} 2s ease-in-out;
`;

const Paragraph = styled.p`
  font-size: 1.5rem;
  color: #ddd;
  margin-bottom: 20px;
  animation: ${fadeIn} 2s ease-in-out;
`;

const DownloadButton = styled.button`
  display: inline-block;
  background-color: #007bff;
  color: white;
  padding: 15px 30px;
  border: none;
  border-radius: 5px;
  font-size: 1.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  animation: ${fadeIn} 2s ease-in-out;

  &:hover {
    background-color: #0056b3;
  }
`;

const FormOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ContactForm = styled.form`
  position: relative;
  background-color: #000000b3;
  padding: 30px;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);

  input,
  textarea {
    width: 100%;
    padding: 10px 0;
    margin-bottom: 15px;
    border: none;
    border-bottom: 1px solid #555;
    font-size: 1.2rem;
    background-color: transparent;
    color: #fff;
    outline: none;
    position: relative;
  }

  input:focus,
  textarea:focus {
    border-bottom: 2px solid #f39c12;
  }

  input::placeholder,
  textarea::placeholder {
    color: rgba(255, 255, 255, 0.7);
    transition: all 0.3s ease;
    transform: translateY(0);
  }

  input:focus::placeholder,
  textarea:focus::placeholder {
    transform: translateY(-15px);
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 1);
  }

  button {
    width: 100%;
    padding: 10px;
    font-size: 1.4rem;
    color: #fff;
    background-color: #f39c12;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgb(245, 127, 23);
    }
  }
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 1.8rem;
  color: #fff;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 5px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;

  &:hover {
    background-color: rgba(0, 0, 0, 0.9);
  }
`;

export default Master;


